// src/redux/slices/loanDisbursementSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// ✅ Use environment variable
const BASE_URL = process.env.REACT_APP_API_URL;

// 🔹 Disburse Loan
export const disburseLoan = createAsyncThunk(
  "loanDisbursement/disburseLoan",
  async ({ loanId, disbursalDate, firstEmiDate, loanDisbursalMode, chargeCollectionMode }, { rejectWithValue }) => {
    try {
      const payload = {
        disbursalDate,          // "2025-07-20"
        firstEmiDate,           // "2025-08-20"
        disbursalRemark: "Disbursed via bank transfer",
        loanDisbursalMode,      // "Bank"
        chargeCollectionMode,   // "Cash"
      };

      const response = await axios.post(
        `${BASE_URL}/generate-emi/${loanId}`, // ✅ use BASE_URL
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message });
    }
  }
);

// 🔹 Fetch EMI Schedule
export const fetchEmiSchedule = createAsyncThunk(
  "loanDisbursement/fetchEmiSchedule",
  async (loanId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/emi-schedule/${loanId}`, // ✅ use BASE_URL
        { headers: { "Content-Type": "application/json" } }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message });
    }
  }
);

const loanDisbursementSlice = createSlice({
  name: "loanDisbursement",
  initialState: {
    loading: false,
    success: null,
    error: null,
    emiSchedule: [],
  },
  reducers: {
    resetDisbursementState: (state) => {
      state.loading = false;
      state.success = null;
      state.error = null;
      state.emiSchedule = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Disburse Loan
      .addCase(disburseLoan.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(disburseLoan.fulfilled, (state, action) => {
        state.loading = false;
        state.success =
          action.payload?.message || "Loan disbursed successfully";
      })
      .addCase(disburseLoan.rejected, (state, action) => {
        state.loading = false;
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : action.payload?.message || "Failed to disburse loan";
      })

      // Fetch EMI Schedule
      .addCase(fetchEmiSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmiSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.emiSchedule = Array.isArray(action.payload)
          ? action.payload
          : [];
      })
      .addCase(fetchEmiSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : action.payload?.message || "Failed to fetch EMI schedule";
      });
  },
});

export const { resetDisbursementState } = loanDisbursementSlice.actions;
export default loanDisbursementSlice.reducer;
